import SelectLanguage from '@/components/general/SelectLanguage';
import BackgroundPanel from '@/components/layout/BackgroundPanel';
import { Outlet } from 'react-router-dom';

export default function FormPanelLayout() {
    return (
        <div className='min-h-screen'>
            <BackgroundPanel />
            <Outlet />
        </div>
    );
}
